"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsAdmin = void 0;

var _getUserInfo = require("ui-addon-upgrades/_core/common/api/getUserInfo");

var _AdminTypes = require("ui-addon-upgrades/_core/common/constants/AdminTypes");

var _logError = _interopRequireDefault(require("ui-addon-upgrades/_core/common/reliability/logError"));

var getIsAdmin = function getIsAdmin(adminType) {
  return (0, _getUserInfo.getUserInfo)().then(function (_ref) {
    var user = _ref.user;

    if (adminType === _AdminTypes.BILLING) {
      var isBillingAdmin = user.scopes.indexOf('billing-write') !== -1;
      return isBillingAdmin;
    }

    var isHubOwner = user.scopes.indexOf('hub-owner') !== -1;
    var isJitaAdmin = user.scopes.indexOf('hub-parcel-write') !== -1;
    return isHubOwner || isJitaAdmin;
  }).catch(function (err) {
    (0, _logError.default)('getIsAdmin', err);
    return false;
  });
};

exports.getIsAdmin = getIsAdmin;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/eligibility/getIsAdmin.js
// module id = 729
// module chunks = 5 6